<template>
  <div id="Lobby">
    <!-- <img class="bg-img" src="@/assets/img/lobby/bg.png" alt="Surreal" /> -->
    <div class="content-area">
      <div class="lobby-title-area">
        <img class="title-img" src="@/assets/img/lobby/logo.png" alt="SURREAL LOGO" />
        <h1 class="title-txt">VCMS中控管理系統</h1>
      </div>
      <!-- <h1 class="content-title">VCMS中控管理系統</h1> -->
      <div class="lobby-center">
        <div class="lobby-item">
          <img class="item-img" src="@/assets/img/lobby/vcms.png" alt="SURREAL VCMS" />
          <div class="item-bg-alpha"></div>
          <h2 class="item-title">中控平台</h2>
          <!-- <h2 class="item-type">中控平台</h2> -->
          <button class="item-btn-more" @click="PageVCMS()">進入</button>
        </div>
      </div>
      <div class="lobby-center">
        <div class="lobby-item">
          <img class="item-img" src="@/assets/img/lobby/teach.png" alt="SURREAL VCMS" />
          <div class="item-bg-alpha"></div>
          <h2 class="item-title">教學平台</h2>
          <!-- <h2 class="item-type">教學平台</h2> -->
          <button class="item-btn-more" @click="PageTeach()">進入</button>
        </div>
      </div>
      <div class="lobby-center">
        <div class="lobby-item">
          <img class="item-img" src="@/assets/img/lobby/backend.png" alt="SURREAL VCMS" />
          <div class="item-bg-alpha"></div>
          <h2 class="item-title">帳號管理</h2>
          <!-- <h2 class="item-type">帳號管理</h2> -->
          <button class="item-btn-more" @click="PageBackend()">進入</button>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
    <div class="lobby-footer">{{`©Copyright ${GetYear()} SURREAL Co., Ltd. | All Rights Reserved `}}</div>
    
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    PageVCMS() {
      let routeData = this.$router.resolve({ name: 'ControllerLogin' });
      window.open(routeData.href, '_blank');
    },
    PageTeach() {
      let routeData = this.$router.resolve({ name: 'Login' });
      window.open(routeData.href, '_blank');
    },
    PageBackend() {
      let routeData = this.$router.resolve({ name: 'BkLogin' });
      window.open(routeData.href, '_blank');
    },
    GetYear(){
      return new Date().getFullYear();
    }
  },
  components: {},
};
</script>

<style>
body {
  overflow: auto;
  min-width: 0;
}
</style>